export const enServerErrorMessages = {
	'serverError.addInstrument': 'Could not add the instrument. Please try again.',
	'serverError.addToWatchlist': 'Could not add the instrument to the watchlist. Please try again.',
	'serverError.addTransaction': 'Could not add the transaction. Please try again.',
	'serverError.createWatchlist': 'Could not create the watchlist. Please try again.',
	'serverError.deleteFromWatchlist': 'Could not remove the instrument from the watchlist. Please try again.',
	'serverError.deleteWatchlist': 'Could not delete the watchlist. Please try again.',
	'serverError.duplicateWatchlist': 'A watchlist with this name already exists.',
	'serverError.findInstrument': 'Could not find the instrument. Please try again.',
	'serverError.importCompletedWithErrors': 'Import completed with errors:',
	'serverError.importFailed': 'Could not import transactions:',
	'serverError.importInvalidPortfolioId': 'Invalid portfolio ID.',
	'serverError.importMissingData': 'Portfolio ID and transactions are required.',
	'serverError.importMissingFiles': 'Select a broker and at least one file.',
	'serverError.importParseFailed': 'Could not process the files:',
	'serverError.importUnsupportedDegiroFile': 'Unsupported Degiro file:',
	'serverError.importUnsupportedDegiroFiles':
		'No supported Degiro files were found. Upload Securities Transactions, Account Overview, or both.',
	'serverError.instrumentIdRequired': 'An instrument is required for this action.',
	'serverError.invalidCredentials': 'Invalid email or password. Please try again.',
	'serverError.invalidPortfolioCurrency': 'Select a valid portfolio currency.',
	'serverError.invalidPortfolioId': 'The portfolio could not be found.',
	'serverError.invalidWatchlistId': 'The watchlist could not be found.',
	'serverError.portfolioNameRequired': 'Enter a portfolio name.',
	'serverError.resetLink': 'Could not send the recovery link. Please try again.',
	'serverError.savePortfolioSettings': 'Could not save portfolio settings. Please try again.',
	'serverError.signIn': 'Could not complete sign in. Please try again.',
	'serverError.signUp': 'Could not create your account. Please try again.',
	'serverError.tickerRequired': 'Enter a ticker symbol.',
	'serverError.updateWatchlist': 'Could not update the watchlist. Please try again.',
	'serverError.watchlistNameLength': 'Watchlist name must be between 1 and 20 characters.',
	'serverError.watchlistNameRequired': 'Enter a watchlist name.',
} as const;

export type ServerErrorMessageId = keyof typeof enServerErrorMessages;

export const svServerErrorMessages: Record<ServerErrorMessageId, string> = {
	'serverError.addInstrument': 'Instrumentet kunde inte läggas till. Försök igen.',
	'serverError.addToWatchlist': 'Instrumentet kunde inte läggas till i bevakningslistan. Försök igen.',
	'serverError.addTransaction': 'Transaktionen kunde inte läggas till. Försök igen.',
	'serverError.createWatchlist': 'Bevakningslistan kunde inte skapas. Försök igen.',
	'serverError.deleteFromWatchlist': 'Instrumentet kunde inte tas bort från bevakningslistan. Försök igen.',
	'serverError.deleteWatchlist': 'Bevakningslistan kunde inte raderas. Försök igen.',
	'serverError.duplicateWatchlist': 'Det finns redan en bevakningslista med det namnet.',
	'serverError.findInstrument': 'Instrumentet kunde inte hittas. Försök igen.',
	'serverError.importCompletedWithErrors': 'Importen slutfördes med fel:',
	'serverError.importFailed': 'Transaktionerna kunde inte importeras:',
	'serverError.importInvalidPortfolioId': 'Ogiltigt portfölj-ID.',
	'serverError.importMissingData': 'Portfölj-ID och transaktioner krävs.',
	'serverError.importMissingFiles': 'Välj en mäklare och minst en fil.',
	'serverError.importParseFailed': 'Filerna kunde inte behandlas:',
	'serverError.importUnsupportedDegiroFile': 'Degiro-filen stöds inte:',
	'serverError.importUnsupportedDegiroFiles':
		'Inga Degiro-filer som stöds hittades. Ladda upp värdepapperstransaktioner, kontoöversikt eller båda.',
	'serverError.instrumentIdRequired': 'Ett instrument krävs för den här åtgärden.',
	'serverError.invalidCredentials': 'Fel e-postadress eller lösenord. Försök igen.',
	'serverError.invalidPortfolioCurrency': 'Välj en giltig portföljvaluta.',
	'serverError.invalidPortfolioId': 'Portföljen kunde inte hittas.',
	'serverError.invalidWatchlistId': 'Bevakningslistan kunde inte hittas.',
	'serverError.portfolioNameRequired': 'Ange ett portföljnamn.',
	'serverError.resetLink': 'Återställningslänken kunde inte skickas. Försök igen.',
	'serverError.savePortfolioSettings': 'Portföljinställningarna kunde inte sparas. Försök igen.',
	'serverError.signIn': 'Inloggningen kunde inte slutföras. Försök igen.',
	'serverError.signUp': 'Kontot kunde inte skapas. Försök igen.',
	'serverError.tickerRequired': 'Ange en ticker.',
	'serverError.updateWatchlist': 'Bevakningslistan kunde inte uppdateras. Försök igen.',
	'serverError.watchlistNameLength': 'Bevakningslistans namn måste vara mellan 1 och 20 tecken.',
	'serverError.watchlistNameRequired': 'Ange ett namn på bevakningslistan.',
};
